import React from 'react';
import './Button.css';

const Button = ({ children, onClick, variant = 'primary', fullWidth, borderRadius = 20, disabled = false }) => {
  return (
    <button 
      className={`custom-button ${variant} ${fullWidth ? 'full-width' : ''}`}
      style={{ borderRadius: `${borderRadius}px` }}
      onClick={onClick}
      disabled = {disabled}
    >
      {children}
    </button>
  );
};

export default Button;
